import Swiper from 'swiper/js/swiper.min';

const scrollMenuListElements = Array.from(document.querySelectorAll('.banks-navigation__content'));
const optionsScrollMenuList = {
    wrapperClass : 'j-scroll-menu',
    slideClass   : 'j-scroll-menu-item',
    slidesPerView: 'auto',
    scrollbar    : {
        el       : '.j-banks-navigation-scrollbar',
        draggable: true
    }
};

if (scrollMenuListElements.length) {
    /* eslint-disable no-new */
    const swiper = new Swiper('.banks-navigation__content', optionsScrollMenuList);
    const allSlides = Array.from(document.querySelectorAll('.banks-navigation .j-scroll-menu-item'));

    if (allSlides.length) {
        const activeIndex = allSlides.findIndex((elem) => {
            return elem.classList.contains('is-active');
        });

        if (activeIndex && activeIndex > 1) {
            swiper.slideTo(activeIndex, 150);
        }
    }
    /* eslint-enable no-new */
}
